@if (displayInformationBanner && currentUser.organisationId === currentOrg) {
  <div id="toast">
    <app-toast
      [toastStyle]="informationBannerType"
      [icon]="informationBannerIcon"
      [text]="informationBannerMessage"
    >
    </app-toast>
  </div>
}
@if (displaySuccessToast) {
  <div id="positive-toast">
    <app-toast toastStyle="positive" icon="checkmark" [text]="successResponse">
    </app-toast>
  </div>
}
@if (canAccessLab) {
  <div id="dashboard--container">
    <div id="header--container">
      <h4>Welcome to your dashboard.</h4>
      <h5>{{ laboratory?.laboratoryName }}</h5>
    </div>
    <hr class="alt" />
    <div id="nav--container">
      <div class="button-one--container">
        <app-option-tab-toggle
          id="toggle--container"
          radioGroup="navigationToggle"
          [selectOptions]="navOptions"
          type="round"
        >
        </app-option-tab-toggle>
        <app-mat-fab-button
          buttonStyle="success"
          iconName="refresh"
          (buttonClicked)="getLogs(true)"
          ariaLabel="Refresh"
        ></app-mat-fab-button>
      </div>
      <div class="button-two--container">
        <app-search-field
          [field]="searchField"
          [parentForm]="errorLogTableControls"
          (buttonClicked)="handleSearch($event)"
        >
        </app-search-field>
        <app-icon-button
          iconName="visibility"
          label="mark all as viewed"
          buttonStyle="secondary"
          buttonId="viewed-btn"
          buttonShape="square"
          title="Mark all as viewed"
          (buttonClicked)="onMarkAllAsViewed()"
          [isDisabled]="
            !(currentUser.role | roleCheck: editAccessRoles) ||
            selectedLogs.length === 0
          "
        ></app-icon-button>
      </div>
    </div>
    @if (errorLogs?.length > 0) {
      <div id="inner-page--container">
        <p id="table-description" style="display: none">
          Error log summary table
        </p>
        <div id="table--container">
          <table aria-describedby="table-description">
            <thead>
              <tr>
                <th id="check" scope="col"></th>
                <th id="device-name" scope="col">
                  <div id="table-header">
                    <span>Device</span>
                  </div>
                </th>
                <th id="error-text" scope="col">
                  <div id="table-header">
                    <span>Error Text</span>
                  </div>
                </th>
                <th
                  id="created-at"
                  scope="col"
                  (click)="onSort('CreatedAt')"
                  [class.active]="currentSort.sortBy === 'CreatedAt'"
                >
                  <div id="table-header">
                    <span>Created At</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th
                  id="viewed"
                  scope="col"
                  (click)="onSort('Viewed')"
                  [class.active]="currentSort.sortBy === 'Viewed'"
                >
                  <div id="table-header">
                    <span>Viewed?</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th id="viewed-by" scope="col">
                  <div id="table-header">
                    <span>Viewed By</span>
                  </div>
                </th>
                <th id="viewed-by-btn" scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (errorLog of errorLogs; track errorLog.id; let i = $index) {
                <tr class="clickable-row" (click)="onViewErrorLog(errorLog)">
                  <td
                    headers="check"
                    id="checkbox-column"
                    (click)="$event.stopPropagation()"
                  >
                    <app-checkbox-group-no-label
                      [option]="getCheckbox(i)"
                      [parentForm]="errorLogTableControls"
                      [formArrayGroupName]="errorLogCheckboxes.key"
                      (checkboxClicked)="errorLogCheckboxClicked($event)"
                      [isDisabled]="errorLog.viewed"
                    >
                    </app-checkbox-group-no-label>
                  </td>
                  <td headers="device-name">
                    <div id="device-name">
                      <div>{{ errorLog.deviceName }}</div>
                      @if (currentUser.role | roleCheck: ogiAdminRoles) {
                        <div class="body2">ID: {{ errorLog.deviceId }}</div>
                      }
                    </div>
                  </td>
                  <td headers="error-text" id="error-text-col">
                    <span class="error-text">{{ errorLog.errorText }}</span>
                    @if (errorLog.notes) {
                      <app-icon-button
                        iconName="article"
                        label="view detail"
                        buttonStyle="transparent--blue"
                        buttonId="detail-btn"
                        buttonShape="square"
                        iconPosition="right"
                        (buttonClicked)="onViewErrorLog(errorLog)"
                      ></app-icon-button>
                    } @else {
                      <app-icon-button
                        iconPosition="right"
                        label="view detail"
                        buttonStyle="transparent--blue"
                        buttonId="detail-btn"
                        buttonShape="square"
                        (buttonClicked)="onViewErrorLog(errorLog)"
                      ></app-icon-button>
                    }
                  </td>
                  <td headers="created-at">
                    {{ errorLog.createdAt | date: "dd/MM/yy, HH:mm a" }}
                  </td>
                  <td headers="viewed" id="viewed-col">
                    <div id="icon">
                      @if (errorLog.viewed) {
                        <mat-icon class="positive">check</mat-icon>
                      }
                      @if (!errorLog.viewed) {
                        <mat-icon class="negative">close</mat-icon>
                      }
                    </div>
                  </td>
                  <td headers="viewed-by">
                    {{ errorLog.viewedBy || "-" }}
                  </td>
                  <td
                    headers="viewed-btn"
                    id="view-cell"
                    (click)="$event.stopPropagation()"
                  >
                    <div>
                      @if (!errorLog.viewed) {
                        <app-mat-outlined-button
                          label="Mark as Viewed"
                          ariaLabel="Mark error log as viewed"
                          [buttonId]="errorLog?.id"
                          (buttonClicked)="
                            onSetErrorLogAsRead([errorLog.id], true)
                          "
                          [isDisabled]="
                            !(currentUser.role | roleCheck: editAccessRoles)
                          "
                        >
                        </app-mat-outlined-button>
                      }
                      @if (errorLog.viewed) {
                        <app-mat-outlined-button
                          label="Mark as Unviewed"
                          ariaLabel="Mark error log as unviewed"
                          [buttonId]="errorLog?.id"
                          (buttonClicked)="
                            onSetErrorLogAsRead([errorLog.id], false)
                          "
                          [isDisabled]="
                            !(currentUser.role | roleCheck: editAccessRoles)
                          "
                        >
                        </app-mat-outlined-button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div id="table-footer">
            <div>
              <span class="body1">
                Page refreshed:
                {{ errorLogListLastUpdated | date: "HH:mm a" }}
              </span>
            </div>
            <div id="pagination--container">
              <div class="select--container">
                <label for="approvals-action">Filter by viewed status</label>
                <app-dropdown-form-field
                  id="action-filter"
                  [field]="errorLogViewedField"
                  [parentForm]="errorLogTableControls"
                >
                </app-dropdown-form-field>
              </div>
              <div class="select--container">
                <label for="logs-per-page">Error logs per page</label>
                <app-dropdown-form-field
                  id="logs-per-page"
                  [field]="errorLogsPerPageField"
                  [parentForm]="errorLogTableControls"
                >
                </app-dropdown-form-field>
              </div>
              <div id="pagination--controls">
                <app-icon-button
                  iconName="chevron_left"
                  buttonId="previous"
                  (buttonClicked)="getPrevious()"
                  [isDisabled]="!hasPrevious"
                ></app-icon-button>
                <span> {{ currentPage }} / {{ totalPages }} </span>
                <app-icon-button
                  iconName="chevron_right"
                  buttonId="next"
                  (buttonClicked)="getNext()"
                  [isDisabled]="!hasNext"
                ></app-icon-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!isLoading && (!errorLogs || errorLogs.length === 0)) {
      <div id="cta--container">
        <h4>No error logs detected</h4>
        <app-icon-button
          label="reset"
          buttonStyle="secondary"
          buttonId="reset-btn"
          iconName="refresh"
          buttonShape="square"
          (buttonClicked)="resetForm()"
        ></app-icon-button>
      </div>
      @if (error) {
        <p class="error">Error: {{ error.message }}</p>
      }
    }
  </div>
  @if (isLoading && !errorLogs?.length) {
    <div id="loading--container">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
} @else {
  <app-error-page
    title="You are not a member of this lab"
    primaryText="Sorry, you cannot access this page unless you are a member of a lab"
  ></app-error-page>
}
<app-error-log-modal
  id="error-log-modal"
  titleText="Error Log"
  [errorLog]="detailViewLog"
  (modalButtonClicked)="addNoteToErrorLog($event)"
  [isProcessing]="isProcessing"
  [errorLogUpdated]="errorLogUpdated"
  [permissionToEdit]="currentUser.role | roleCheck: ogiAdminRoles"
></app-error-log-modal>
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="closeModal('error')"
></app-modal>
